export const PressSection = ({ press, texts }) => {
  const names = press.length ? press.map((p) => p.name) : ["MediaCat", "Onedio", "Campaign Türkiye"];
  const row = Array(4).fill(names).flat();
  return (
    <section data-testid="press-section" className="relative z-10 py-20 md:py-28 bg-[#0A0A0A] border-t border-b border-[#1a1a1a] overflow-hidden">
      <p className="text-[#525252] tracking-[0.5em] text-xs uppercase mb-10 px-6 md:px-12 lg:px-24">
        — {texts.press_title || "Basında Cellat"}
      </p>
      <div className="marquee-track marquee-track-slow">
        {row.map((name, i) => (
          <span key={i} className="whitespace-nowrap font-blackletter text-3xl md:text-5xl text-[#333333] hover:text-[#8B0000] transition-colors duration-500 px-8">
            {name} <span className="text-[#8B0000]/40 text-2xl align-middle">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
